import request from '../../app/api/requests';
import { getSessionEpoch } from '../lib/auth/session';

// Keep the calendar ID in UI state. Numeric endpoints receive a persisted occurrence ID.
export async function resolveTaskId(task: any): Promise<string | number> {
    const id = typeof task === 'object' && task !== null ? task.id : task;
    if (!String(id ?? '').includes('&')) {
        if (!/^[1-9]\d*$/.test(String(id ?? ''))) throw new Error('Invalid task ID');
        return id;
    }
    const epoch = getSessionEpoch();
    const {data} = await request.post('/Task/occurrences/resolve', {taskId: String(id)});
    if (getSessionEpoch() !== epoch) throw new Error('Session changed');
    if (!data || !/^[1-9]\d*$/.test(String(data.originalId))) throw new Error('Invalid occurrence response');
    return data.originalId;
}
